import { Glossary } from '@models/glossary';
import { ArticleEntityAdminService } from './articleEntityAdminService';

export class GlossaryAdminService extends ArticleEntityAdminService<Glossary> {
    constructor() {
        super('/api/admin/glossary');
    }
}
